import { action, computed, makeObservable, observable, runInAction } from "mobx";
import { MenuItem } from "shared/models/spaceStone/menuItem";
import { orderBy } from "lodash";
import { getMenu } from "shared/api/spaceStone/menuApi";

export enum LayoutType {
    BasicLayout,
    FullWidthLayout,
}

export class LayoutStore {
    @observable public menuItems: MenuItem[] = [];
    @observable private layoutType: LayoutType = LayoutType.BasicLayout;
    @observable public isMenuToggled = false;

    constructor() {
        makeObservable(this);
    }

    @action.bound
    public changeLayoutType(type: LayoutType): void {
        if (this.layoutType !== type) {
            this.layoutType = type;
        }
    }

    @action.bound
    public async fetchMenuItems(): Promise<void> {
        const response = await getMenu();
        runInAction(() => {
            this.menuItems = response;
        });
    }

    @action.bound
    public setMenuItems(menuItems: MenuItem[]): void {
        this.menuItems = orderBy(menuItems, menuItem => menuItem.sortOrder);
    }

    @action.bound
    public openMenu(): void {
        this.isMenuToggled = true;
    }

    @action.bound
    public closeMenu(): void {
        this.isMenuToggled = false;
    }

    @computed
    get currentLayout(): LayoutType {
        return this.layoutType;
    }
}
